import { DefaultState, DropdownItem } from 'store/types';
import { Filters } from 'store/types';

export const GET_LOCATIONS_FOR_FILTER_REQUEST = 'GET_LOCATIONS_FOR_FILTER_REQUEST';
export const GET_LOCATIONS_FOR_FILTER_SUCCESS = 'GET_LOCATIONS_FOR_FILTER_SUCCESS';
export const GET_LOCATIONS_FOR_FILTER_FAILURE = 'GET_LOCATIONS_FOR_FILTER_FAILURE';

export interface GetLocationsForFilterParams {
  filters: Filters;
  paging: {
    page: number;
    pageSize: number;
  };
};

export interface GetLocationsForFilterData {
  rows: DropdownItem[];
  totalCount: number;
}

export type GetLocationsForFilterState = DefaultState & {
  contents?: GetLocationsForFilterData;
};

interface ReadGetLocationsForFilterRequest {
  type: typeof GET_LOCATIONS_FOR_FILTER_REQUEST;
};

interface ReadGetLocationsForFilterSuccess {
  type: typeof GET_LOCATIONS_FOR_FILTER_SUCCESS,
  contents: GetLocationsForFilterData;
}

interface ReadGetLocationsForFilterFailure {
  type: typeof GET_LOCATIONS_FOR_FILTER_FAILURE;
}

export type GetLocationsForFilterActionTypes = ReadGetLocationsForFilterRequest | ReadGetLocationsForFilterSuccess | ReadGetLocationsForFilterFailure;
